<!--
* @Author : DingHuiHui
* @Content : 兑换卡付款
-->
<template>
  <div class="pay">
    <header>
      <div class="tip">
        <p>你好，欢迎使用兑换卡付款！</p>
      </div>
      <div class="logo">
        <p>
          <img src="~@assets/images/purchase/card_logo.png" alt="">
          <span>我的收银台</span>
        </p>
      </div>
    </header>
    <div class="content">
      <ul :class="['details']">
        <div>
          正在使用即时到账交易
        </div>
        <li class="bold">
          <span>{{ type }}{{ $t('private.purchase.step2.sub') }}</span>
          {{ buyType == 2 ? $tc('private.purchase.step2.typeValue', 1) : $tc('private.purchase.step2.typeValue', 2) }}
        </li>
      </ul>
      <div class="payment">
        <div class="card_panel">
          <h3>卡密验证</h3>
          <a-row type="flex" justify="space-between" class="form_row">
            <a-col :span="14">
              <a-form class="senior_form" layout="inline" >
                <a-form-item label="卡类型" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                  <a-input style="width:100%;" value="兑换卡" readOnly/>
                </a-form-item>
                <a-form-item label="卡密" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                  <a-input style="width:100%;" placeholder="卡密不区分大小写" v-model="cardPwd"/>
                </a-form-item>
                <!-- <a-form-item label="验证码" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                  <a-input style="width:100px;" value="兑换卡"/>
                  <GetCode></GetCode>
                </a-form-item> -->
                <a-form-item :wrapper-col="{ span: 14, offset: 6 }">
                  <a-button type="primary" @click="handlePay" :loading="payLoading"> 立即支付 </a-button>
                </a-form-item>
              </a-form>
            </a-col>
            <a-col :span="10" class="card_style"></a-col>
          </a-row>
        </div>
        <!-- <span :class="['detail-btn']" @click="hideDetail = !hideDetail">订单详情</span> -->
      </div>
    </div>
  </div>
</template>

<script>
import { payOrder } from '@/api/purchase'
import GetCode from './components/CanvasCode'
import { mapGetters } from 'vuex'

export default {
  name: 'PayCard',
  components: { GetCode },
  data () {
    return {
      info: JSON.parse(this.$route.query.de || '{}'),
      cardPwd: '',
      payLoading: false
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 产品类型
    type () {
      return `${this.info.model === 1 ? 'studio' : 'robot'}`
    },
    // 购买类型 1：新购/2：续费
    buyType () {
      return `${this.info.id >= 0 ? 2 : 1}`
    }
  },
  created () {
    console.log(JSON.parse(this.$route.query.de))
  },
  methods: {
    /**
     * 立即支付
     */
    handlePay () {
      if (this.cardPwd) {
        if (this.cardPwd.length > 21) {
          this.$message.error('卡密码不超过21位')
          return
        }
      } else {
        this.$message.error('卡密码必填')
        return
      }
      const par = {
        productCategory: this.type,
        prodType: this.type,
        ecardNo: this.cardPwd,
        dctPrice: this.info.dctPrice,
        origPrice: this.info.origPrice,
        subject: this.type,
        body: this.type,
        productName: this.type,
        instanceNo: this.info.instanceNo || '',
        custNo: JSON.parse(this.userInfo).custNo,
        orderMonth: 12,
        orderModel: this.buyType,
        count: 1
      }
      payOrder(3, par).then(data => {
        console.log(data)
        if (data.code === 0) {
          this.$message.success('支付成功')
          this.$router.push(`/robot&studio/list`)
        } else {
          this.$message.error(data.msg)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.pay{
  header{
    .tip{
      height: 30px;
      line-height: 30px;
      font-size: 12px;
      color: #fff;
      background-color: #4D4D4D;
      p{
        width: 950px;
        margin: 0 auto;
        text-align: right;
      }
    }
    .logo{
      height: 60px;
      line-height: 60px;
      font-size: 12px;
      color: #999999;
      background:rgba(255,255,255,1);
      box-shadow:0px 1px 0px 0px rgba(221,221,221,1);
      p{
        width: 950px;
        margin: 0 auto;
        img{
          padding-right: 12px;
          margin-right: 12px;
          border-right: 1px solid #DDDDDD;
          display: inline-block;
        }
      }
    }
  }
  .content{
    width: 950px;
    margin: 0 auto;
    .details{
      font-size: 12px;
      color: #333;
      padding: 24px;
      line-height: 22px;
      position: relative;
      &.hide{
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        padding-right: 70%;
        li{
          display: inline-block;
          margin-right: 10px;
        }
      }
      .bold{
        line-height: 24px;
      }
      .money{
        position: absolute;
        font-size: 12px;
        color: #333333;
        line-height: 24px;
        bottom: 15px;
        right: 0;
        strong{
          font-size: 22px;
          color: #FF6600;
          font-weight: bold;
          margin-right: 8px;
        }
      }
    }
    .payment{
      position: relative;
      border: 3px solid #b3b3b3;
      border-left: 0;
      border-right: 0;
      background: #fff;
      // overflow: hidden;
      min-height: 460px;
      // text-align: center;
      .card_panel {
        padding: 50px 60px 127px;
        h3 {
          font-size: 16px;
          color: #333;
          font-weight: bold;
          margin-bottom: 60px;
        }
        .form_row {
          & > div:first-child {
            padding: 52px 60px 52px 0;
            border-right: 1px solid #eee;
          }
        }
      }
      .detail-btn{
        position: absolute;
        top: -24px;
        right: 24px;
        background: #b3b3b3;
        color: #fff;
        font-size: 12px;
        line-height: 24px;
        padding: 0 7px;
        font-weight: 700;
        cursor: pointer;
      }
    }
  }
  .card_style {
    background: url('~@assets/images/purchase/card_bg.png') no-repeat center;
  }
}
</style>
